// removed by extract-text-webpack-plugin
module.exports = {"primary-mail":"mail-module-primary-mail-ba8112182ab87debe9fb015ec9906154--","composed-mail":"mail-module-composed-mail-d6e215082cd5edf0f44ba0339d7dcdb2--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailThread/mail/mail.module.scss
// module id = 1916
// module chunks = 0